import { render, staticRenderFns } from "./ElementOrderTableColumn.vue?vue&type=template&id=72470f00"
import script from "./ElementOrderTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementOrderTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports